import React, { ReactNode, useContext } from 'react';
import {
	blueMediumColor,
	redMediumColor
} from '../../styles/GlobalStyle';
import { CloseIcon, CollapseIcon, ExpandIcon, MineSweeperIcon } from './common/icon-components';
import { Button } from './common/styles-components';
import { GameInterfaceContext } from '../../providers/GameInterfaceProvider';
import { DropdownLanguage, DropdownLevel } from './common/Dropdown';

import { useTranslation } from 'react-i18next';
import { ButtonsXP, HeaderXP, MenuXP, TitleXP, WrapperXP } from '../layout/XPInterfaces';

interface Props {
	children?: ReactNode;
}

export const ProgramInterface = ({ children }: Props) => {
	const { t } = useTranslation();

	const { gameInterface, setGameInterface } = useContext(GameInterfaceContext);

	const closeGame = (): void => {
		setGameInterface({ isVisible: false });
	};

	return (
		<WrapperXP isVisible={gameInterface.isVisible}>
			<HeaderXP>
				<TitleXP>
					<MineSweeperIcon/>
					{t('GameName')}
				</TitleXP>
				<ButtonsXP>
					<Button color={blueMediumColor} disabled={true}><CollapseIcon/></Button>
					<Button color={blueMediumColor} disabled={true}><ExpandIcon/></Button>
					<Button color={redMediumColor} disabled={false} onClick={closeGame}><CloseIcon/></Button>
				</ButtonsXP>
			</HeaderXP>
			<MenuXP>
				<DropdownLevel/>
				<DropdownLanguage/>
			</MenuXP>
			{children}
		</WrapperXP>
	);
};
